import { ChangeDetectorRef, inject, Pipe, PipeTransform } from '@angular/core';

import { MomentService } from './moment.service';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime } from 'rxjs';

@Pipe({
    name: 'eventDate',
    standalone: false,
    pure: false,
})
export class EventDatePipe implements PipeTransform {
    transformResultRecords: { [valueAsKey: string]: string } = {};
    cdr = inject(ChangeDetectorRef);
    translateSvc = inject(TranslateService);

    constructor(private momentSvc: MomentService) {
        this.translateSvc.onLangChange.pipe(debounceTime(300)).subscribe(() => {
            // when language is changed we need to clear the cache and trigger new date-format result
            this.transformResultRecords = {};
            this.cdr.markForCheck();
        });
    }

    transform(value: string | Date, ...args: any[]): string {
        if (!value) {
            return '';
        }
        const valueAsKey = typeof value === 'string' ? value : value.toString();
        if (this.transformResultRecords[valueAsKey]) { // read from cache if exists to improve performance
            return this.transformResultRecords[valueAsKey];
        }
        const timeZone = args[0];
        const formatType = args[1];
        const result = this.momentSvc.toEventDateTime(value, timeZone, formatType);
        this.transformResultRecords[valueAsKey];
        return result;
    }
}
